import csSubscription from './locales/cs/subscription.json';
import enSubscription from './locales/en/subscription.json';
import ruSubscription from './locales/ru/subscription.json';

export const subscriptionTranslations = { en: enSubscription, ru: ruSubscription, cs: csSubscription };
